import script from "./RelogioCircular.vue?vue&type=script&setup=true&lang=js"
export * from "./RelogioCircular.vue?vue&type=script&setup=true&lang=js"

import "./RelogioCircular.vue?vue&type=style&index=0&id=1e07e0ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e07e0ce"]])

export default __exports__